// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import checkoutSharedStyles from "@conklin/App/SharedStyles/CheckoutStyles";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";

type Props = WidgetProps;

const CheckoutShippingSectionContainer = ({ id }: Props) => {
    return (
        <StyledWrapper {...checkoutSharedStyles.container}>
            <StyledWrapper {...checkoutSharedStyles.section}>
                <XngZone contentId={id} zoneName="content0" />
            </StyledWrapper>
            <StyledWrapper {...checkoutSharedStyles.section}>
                <XngZone contentId={id} zoneName="content1" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CheckoutShippingSectionContainer,
    definition: {
        displayName: "Shipping Section Container",
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;
